export default __webpack_public_path__ + "static/media/GeoSinergiaLogo.b48de140.svg";